<template>
  <div class="errorbar-block">
    <div class="errorbar-wrap">
      <div class="topline">100</div>
      <div class="centerline">50 全体平均</div>
      <div class="btmline">0</div>
      <div v-for="(item,num) in items" class="error-bar" :key="num">
        <div class="grapharea">
          <div class="bar -blue" :style="setPosition(item,num,'blue')"></div>
          <div class="bar -red" :style="setPosition(item,num,'red')"></div>
          <div class="ebar -eblue" :style="setPosition(item,num,'eBlue')"></div>
          <div class="ebar -ered" :style="setPosition(item,num,'eRed')"></div>
        </div><!-- .grapharea -->
        <div class="graphbtm">
          <div class="barname">{{item.name}}</div>
          <p class="barexp">{{item.exp}}</p>
        </div><!-- .graphbtm -->
      </div><!-- .error-bar -->
    </div><!-- .errorbar-wrap -->
    <div class="ebar-label">
      <span class="labels -blue">上位置</span>
      <span class="labels -red">下位置</span>
    </div><!-- .ebar-label -->
  </div><!-- .errorbar-blcok -->
</template>

<script>
export default {
  props: ["ebardata"],
  data() {
    return {
      items: this.ebardata,
    };
  },
  computed: {
    setPosition() {
      return function (item, num, type) {
        let height;
        let bottom;
        if (type == "blue") {
          height = item.blue;
          bottom = 0;
        } else if (type == "red") {
          height = item.red;
          bottom = 0;
        } else if (type == "eBlue") {
          height = item.eBlue * 2;
          bottom = item.blue - item.eBlue;
        } else if (type == "eRed") {
          height = item.eRed * 2;
          bottom = item.red - item.eRed;
        }
        return "height:" + height + "%;bottom:" + bottom + "%";
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.errorbar-block{
  background-color: #cde6f5;
  padding: 10px 10px 0;
  margin-bottom: 60px;
}
.errorbar-wrap {
  box-sizing: border-box;
  // height: 300px;
  width: 100%;
  // max-width: 500px;
  padding-left: 30px;
  display: flex;
  position: relative;
  > .error-bar {
    flex: 1 1 33%;
  }
  > .centerline {
    position: absolute;
    left: 0;
    top: 140px;
    width: 100%;
    height: 20px;
    line-height: 20px;
    z-index: 10;
    font-size: 1.2rem;
    &::before {
      content: "";
      position: absolute;
      height: 1px;
      left: 65px;
      right: 0;
      top: 10px;
      border-bottom: 1px dotted #aaa;
    }
  }
  > .topline {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 20px;
    line-height: 20px;
    z-index: 10;
    font-size: 1.2rem;
    &::before {
      content: "";
      position: absolute;
      height: 1px;
      left: 45px;
      right: 0;
      top: 10px;
      border-bottom: 1px dotted #aaa;
    }
  }
  > .btmline {
    position: absolute;
    left: 0;
    top: 290px;
    height: 20px;
    line-height: 20px;
    z-index: 10;
    font-size: 1.2rem;
  }
}
.error-bar {
  position: relative;
  transform-origin: bottom left;
  animation: ebar-move 1.2s;
  animation-fill-mode: forwards;

  >.grapharea{
    position: relative;
    width: 100%;
    height: 300px;
    background-color: #fff;
  }
  .bar {
    position: absolute;
    // top:300px;
    // bottom: 0;
    width: 25%;
    box-sizing: border-box;
    &.-blue {
      background-color: #1788dd;
      left: 25%;
    }
    &.-red {
      background-color: #eb4964;
      left: 55%;
    }
  }
  .ebar {
    position: absolute;
    bottom: 0;
    width: 10%;
    box-sizing: border-box;
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
    &::after {
      content: "";
      position: absolute;
      display: block;
      width: 1px;
      height: 100%;
      background-color: #000;
      left: 49%;
    }
    &.-eblue {
      left: 32.5%;
    }
    &.-ered {
      left: 62.5%;
    }
  }
  .graphbtm{
    padding-top: 10px;
  }
  .barname {
    width: 100%;
    text-align: center;
  }
  .barexp{
    padding: 10px 15px;
    font-size: 1.4rem;
  }
}

.ebar-label {
  display: flex;
  justify-content: center;
  background-color: #fff;
  padding-top: 10px;
  margin: 0 -10px;
  // max-width: 500px;
  // margin-bottom: 40px;
  > .labels {
    margin: 0 10px;
    &::before {
      content: "";
      display: inline-block;
      width: 10px;
      height: 10px;
      background-color: #eb4964;
      margin-right: 5px;
    }
    &.-blue {
      &::before {
        background-color: #1788dd;
      }
    }
  }
}
@keyframes ebar-move {
  from {
    transform: scaleY(0);
    opacity: 0;
  }
  to {
    transform: scaleY(1);
    opacity: 1;
  }
}
</style>